import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 供应商评级评分管理
 */
export default {
  path: 'rating-manage',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '供应商评级评分管理',
    icon: 'icon-side_statistics_data'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 评级设置
    {
      path: 'grade-setting',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '评级设置'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 评级列表
        {
          path: 'list',
          name: 'GradeSettingList',
          component: '/supplier-manage-views/rating-manage/grade-setting/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '评级列表',
            cache: true,
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 评分设置
    {
      path: 'score-setting',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '评分设置'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 评级列表
        {
          path: 'list',
          name: 'ScoreSettingList',
          component: '/supplier-manage-views/rating-manage/score-setting/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '评分列表',
            cache: true,
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
